// src/pages/SubcodonProfile/components/BatchTranscriptList.jsx
import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Tooltip } from "react-tooltip";

const BatchTranscriptList = ({ transcriptList, onUpdateTranscriptList }) => {
  const InfoTooltip = ({ id, content }) => (
    <>
      <AiOutlineInfoCircle
        data-tooltip-id={id}
        title={content}
        style={{
          marginLeft: "4px",
          cursor: "help",
          color: "#6B7280",
          fontSize: "16px",
          verticalAlign: "middle",
          display: "inline-flex",
          alignItems: "center",
        }}
      />
    </>
  );

  return (
    <Card
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "1px",
        height: "100%",
        minHeight: "200px",
      }}
    >
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <h5
            className="mb-0 fw-semibold d-flex align-items-center"
            style={{ color: "#1a6d51" }}
          >
            <i className="ri-file-list-3-line me-2 "></i>
            Transcript List{" "}
          </h5>
        </div>
      </CardHeader>

      <CardBody className="py-3">
        <FormGroup className="mb-0">
          <Label
            for="transcriptList"
            className="d-flex align-items-center mb-2"
          >
            Transcript IDs:
            <InfoTooltip
              id="tt-batch-transcript-list"
              content="Enter a list of genes or transcript ID's seperated by commas or spaces, this can also be copy/pasted directly from an excel sheet. If genes are entered the files returned will be based on the principal transcript of each gene. The list needs to consist of only transcript ID's or only gene names, mixing transcript ID's and gene names will result in an error."
            />
          </Label>
          <Input
            id="transcriptList"
            type="textarea"
            rows="3"
            value={transcriptList}
            onChange={(e) => onUpdateTranscriptList(e.target.value)}
            placeholder={`Enter transcript IDs (one per line or comma separated):
ENST00000368885
ENST00000316292
`}
            style={{
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              fontSize: "14px",
              padding: "12px",
              backgroundColor: "#ffffff",
              fontFamily: "monospace",
              resize: "vertical",
            }}
          />
          <small className="text-muted mt-2 d-block">
            <i className="ri-information-line me-1"></i>
            You can paste transcript IDs directly from Excel or other
            spreadsheets
          </small>
        </FormGroup>
      </CardBody>
    </Card>
  );
};

export default BatchTranscriptList;
